import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsFindBy } from 'services/WService.js';
import { wsGetAll } from 'services/WService';

export default WithApp(function ModalCuotaColgateIcentivo(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [products, setProducts] = useState([]);
  const [coberturas, setCoberturas] = useState([]);

  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);
  const [zonas, setZonas] = useState([]);
  const [mesas, setMesas] = useState([]);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listProducts() {
    let response = await wsFindBy('logi/product', { base_business_partner_id: 7, deleted_at: 'null', state: 'A' });
    if (response.success) setProducts(response.data);
  }

  async function listCoberturas() {
    let response = await wsFindBy('sale/reglas-cobertura', { state: 'A', deleted_at: 'null' });
    if (response.success) setCoberturas(response.data);
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZonas(response.data);
  }
  async function listMesas() {
    let response = await wsFindBy('base/bureau', {base_zone_id: dataChanging.base_zone_id, state: 'A', delete_at: null});
    if (response.success) setMesas(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        base_rule_id: null,
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            base_rule_id: item.CODIGOCOBERTURA,
            min_coverage: item.MINCLIENTE,
            max_coverage: item.MAXCLIENTE,
            ganancia: item.GANANCIA,
            only_logi_product_id: item.IDPRODUCTOEXCLUSIVO,
          };
        }),
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.base_rule_id) {
      setDataChanging((prev) => ({
        ...prev,
        base_rule_id: bPartnerSelect?.base_rule_id || '',
      }));
    }
  }, [bPartnerSelect]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) {listProducts();listCoberturas();listZones();};
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  useEffect(() => {
    if (dataChanging.base_zone_id) {
      setMesas([]);
      listMesas();
    }
  }, [dataChanging.base_zone_id]);
  return (
    <>
      <Modal
        title={`Nueva regla de rango de cobertura`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.base_rule_id
            ? 'sale/rango-cobertura'
            : 'sale/rango-cobertura/multiple'
        }
        dataForce={
          dataChanging.base_rule_id
            ? {
              base_rule_id: dataChanging.base_rule_id,
              only_logi_product_id: dataChanging.only_logi_product_id,
              base_bureau_id: dataChanging.base_bureau_id,
              }
            : {
                base_rule_id: cuota.valueSearch?.base_rule_id,
                customers: bPartnerSelect?.customers
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={coberturas}
            getOptionLabel={(item) => `${item.cobertura} (Código: ${item.code})`}
            renderInput={(params) => (
              <TextField {...params} label="Coberturas" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('base_rule_id', item?.id); setDataImport(null);}}
            value={coberturas.find((seller) => seller.id === dataChanging.base_rule_id) || null}
            // style={{ flexGrow: 1, marginRight: '10px' }}
            fullWidth
          />
          {/* <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate="CODIGOCOBERTURA"
            sortDuplicate="CODIGOCOBERTURA"
            downTemplate={{
              fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla de cuota colgate`,
              fields: ['CODIGOCOBERTURA','MINCLIENTE','MAXCLIENTE','GANANCIA','IDPRODUCTOEXCLUSIVO']
            }}
          /> */}
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.base_rule_id ? (
          <>
            <Autocomplete
              disableClearable
              options={products}
              getOptionLabel={(item) => `${item.ItemName} (Código: ${item.ItemCode})`}
              renderInput={(params) => (
                <TextField {...params} label="Producto exclusivo" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('only_logi_product_id', item?.id);}}
              value={products.find((product) => product.id === dataChanging.only_logi_product_id) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <TextField
              label="Clientes Minimos"
              fullWidth
              type="number"
              name="min_coverage"
              margin="normal"
              value={dataChanging.min_coverage || ''}
              onChange={(e) => handleChange('min_coverage', e.target.value)}
              required
            />
            <TextField
              label="Clientes maximos (Opcional)"
              fullWidth
              type="number"
              name="max_coverage"
              margin="normal"
              value={dataChanging.max_coverage || ''}
              onChange={(e) => handleChange('max_coverage', e.target.value)}
            />
            <TextField
              label="Ganancia"
              fullWidth
              type="number"
              name="ganancia"
              margin="normal"
              value={dataChanging.ganancia || ''}
              onChange={(e) => handleChange('ganancia', e.target.value)}
              required
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});
